import React from "react";

export default function Verified() {
  return (
    <svg width="175" height="175" viewBox="0 0 175 175" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M149.372 25.6279C132.845 9.10171 110.872 0 87.5 0C64.1276 0 42.1542 9.10171 25.6279 25.6279C9.10137 42.1545 0 64.1279 0 87.5C0 110.872 9.10137 132.845 25.6279 149.372C42.1545 165.898 64.1276 175 87.5 175C110.872 175 132.845 165.898 149.372 149.372C165.898 132.845 175 110.872 175 87.5C175 64.1279 165.898 42.1548 149.372 25.6279ZM87.5 164.746C44.9063 164.746 10.2539 130.094 10.2539 87.5C10.2539 44.9063 44.9063 10.2539 87.5 10.2539C130.094 10.2539 164.746 44.9063 164.746 87.5C164.746 130.094 130.094 164.746 87.5 164.746Z"
        fill="#1D79FB"
      />
      <path
        d="M129.303 59.4245C127.301 57.423 124.054 57.423 122.053 59.4249L76.7785 104.699L52.9461 80.8665C50.9442 78.8645 47.6978 78.8645 45.6955 80.8665C43.6933 82.8684 43.6933 86.1147 45.6955 88.117L73.1531 115.575C74.1542 116.576 75.4664 117.076 76.7782 117.076C78.09 117.076 79.4025 116.575 80.4033 115.575L129.303 66.6751C131.305 64.6731 131.305 61.4268 129.303 59.4245Z"
        fill="#1D79FB"
      />
    </svg>
  );
}
